export default "__VITE_PUBLIC_ASSET__abbda209__"